/*
 * 戒导航 · 下载中心模块（jiedh/downloads）—— 前台扩展声明
 *
 * 设计依据：doc/知识库与文件下载中心设计方案.md §5.5。
 *
 * ⚠️ 2026-10-10 改造（用户指令）：下载中心前台由「服务端渲染独立页」
 *    （自带页头，即所谓「首页样式」）改为「渲染在论坛 SPA 外壳内」
 *    （即所谓「论坛样式」），与 packages/checkin 的戒打卡完全一致。
 *
 * 这里只注册**前端路由**：三条 route 共用同一个页面组件 DownloadPage。
 *   ① downloads          → /downloads           下载中心首页（分类 + 最新资料）
 *   ② downloads.category → /downloads/c/:slug   分类页（分页资料列表）
 *   ③ downloads.show     → /downloads/r/:slug   资料详情页（文件清单 / 下载）
 *
 * ★ 机制（与 checkin 完全同范式，缺一不可）：
 *   - 后端 extend.php §七 用 Extend\Frontend('forum')->route('/downloads', 'downloads')
 *     把路径**放行**给 SPA（否则浏览器首屏直连 /downloads 会在服务端 404）；
 *   - 前端这里用 Extend.Routes().add(routeName, path, Component) 注册客户端路由，
 *     由 Flarum 的 DefaultResolver 在 SPA 内按 routeName 实例化对应组件。
 *   - 二者 routeName 必须逐字一致（'downloads' / 'downloads.category' / 'downloads.show'）。
 *
 * ★ 路径参数语法差异（本项目已多次踩坑）：
 *   - PHP / FastRoute（服务端放行）用 `{slug}`；
 *   - JS / Mithril（客户端匹配）用 `:slug`。
 *   写反了会导致「首屏直连正常、SPA 内跳转失效」或反之。
 *
 * ★ 为什么三条路由共用一个组件类：
 *   核心 DefaultResolver.makeKey() = routeName + JSON.stringify(m.route.param())，
 *   路由名或参数变化都会让组件**销毁重建**（oninit 重跑 → 重新拉数据）；
 *   组件内再按 this.attrs.routeName 分支渲染不同视图即可，无需三个类。
 *   ?page=N 也参与 param()，因此翻页同样触发重建与重新拉取。
 *
 * ★ 数据来源：DownloadDataController（后端 §四 的 /downloads/data* JSON 路由），
 *   组件用 app.request 拉取；页面只负责渲染，不查库、不判权限（权限在后端把关）。
 */
import Extend from 'flarum/common/extenders';
import DownloadPage from './components/DownloadPage';
export default [
// ① 下载中心首页
new Extend.Routes().add('downloads', '/downloads', DownloadPage),
// ② 分类页：/downloads/c/:slug（JS 侧用 :slug，对应后端 {slug}）
new Extend.Routes().add('downloads.category', '/downloads/c/:slug', DownloadPage),
// ③ 资料详情页：/downloads/r/:slug
new Extend.Routes().add('downloads.show', '/downloads/r/:slug', DownloadPage)];